import { render } from "./OSList.vue?vue&type=template&id=755f0a6b&scoped=true"
import script from "./OSList.vue?vue&type=script&lang=js"
export * from "./OSList.vue?vue&type=script&lang=js"

import "./OSList.vue?vue&type=style&index=0&id=755f0a6b&scoped=true&lang=css"

import exportComponent from "X:\\GRV\\CPS5\\Projetos\\CPSDashApontamento\\WebDashBoard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-755f0a6b"]])

export default __exports__